import chalk from 'chalk'
import inquirer, { Question } from 'inquirer'
import emoji from 'node-emoji'
import path from 'path'

import { generateTemplate, writeTemplateFileSync } from '../../utils'
import { isValidBasicStringOfLengthN } from '../validators'

const askQuestions = inquirer.prompt

const circleCITemplatePath = path.resolve(__dirname, '..', '..', '..', 'templates', 'circleci', 'config.yml')

const circleCIOutputDirectory = path.resolve('.circleci')

const circleCIQuestions: Question[] = [
  {
    type: 'input',
    name: 'nodeVersion',
    prefix: emoji.get('rocket'),
    message: `Please enter the node version you'd like to use ${chalk.underline.green('(e.g. 12.8.4)')}:`,

    validate: isValidBasicStringOfLengthN(2),
  },
  {
    type: 'input',
    name: 'xcodeVersion',
    prefix: emoji.get('i_love_you_hand_sign'),
    message: `Please enter the xcode version you'd like to use ${chalk.underline.green('(e.g. 12.3.0)')}:`,
    validate: isValidBasicStringOfLengthN(2),
  },
  {
    type: 'input',
    name: 'androidVersion',
    prefix: emoji.get('rocket'),
    message: `Please enter the android version you'd like to use ${chalk.underline.green('(e.g. api-30-node)')}:`,
    validate: isValidBasicStringOfLengthN(1),
  },
  {
    type: 'input',
    name: 'lintCommand',
    prefix: emoji.get('comet'),
    message: `Please enter the linting command you'd like to use ${chalk.underline.green('e.g. lint')}`,
    validate: isValidBasicStringOfLengthN(1),
  },
  {
    type: 'input',
    name: 'auditCommand',
    prefix: emoji.get('comet'),
    message: `Please enter the audit command you'd like to use ${chalk.underline.green('e.g. audit:critical')}`,
    validate: isValidBasicStringOfLengthN(1),
  },
  {
    type: 'input',
    name: 'testCommand',
    prefix: emoji.get('comet'),
    message: `Please enter the test command you'd like to use ${chalk.underline.green('e.g. _ci:test')}`,
    validate: isValidBasicStringOfLengthN(1),
  },
]

const generateCircleCI = async (questions: Question[]) => {
  try {
    console.info(`${chalk.red('Starting generation of CircleCI template ... this will overwrite your config.yml')} \n`)
    const answers = await askQuestions(questions)
    const templateString = generateTemplate(circleCITemplatePath, answers)
    writeTemplateFileSync(circleCIOutputDirectory, 'config.yml', templateString)
    console.info('Generated config.yml at:', circleCIOutputDirectory)
  } catch (error) {
    console.error(error.message)
  }
}

export const command = 'generate'
export const desc = 'Generate CircleCI boilerplate in your React Native project'
export const handler = async (): Promise<void> => generateCircleCI(circleCIQuestions)
